import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useMaintenance } from "../context/MaintenanceContext";
import { LogOut, User, Upload, Shield, Search } from "lucide-react";
import { useState } from "react";

export default function Header() {
  const { user, logout } = useAuth();
  const { enabled: maintEnabled } = useMaintenance();
  const nav = useNavigate();
  const loc = useLocation();
  const [q, setQ] = useState("");
  const authed = user && user !== false;
  // When maintenance is ON and viewer is NOT admin, hide marketing nav items
  // since their destinations are gated. Sign-in stays accessible as the escape hatch.
  const isAdmin = authed && user.role === "admin";
  const hideMarketingNav = maintEnabled && !isAdmin;

  const onSearch = (e) => {
    e.preventDefault();
    if (q.trim()) nav(`/browse?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <header className="glass sticky top-0 z-50 w-full" data-testid="site-header">
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 lg:px-12 h-16">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="logo-link">
          <span className="relative inline-flex h-10 w-10 items-center justify-center rounded-full overflow-hidden bg-[#FDF0CA] ring-1 ring-white/10 transition-transform group-hover:scale-105">
            <img src="/logo192.png" alt="Christoreel" className="h-10 w-10 object-cover" />
          </span>
          <span className="font-display text-2xl font-black tracking-tighter">Christo<span className="text-[#E65F2B]">reel</span></span>
        </Link>

        {loc.pathname.startsWith("/browse") || authed ? (
          <form onSubmit={onSearch} className="hidden md:flex items-center flex-1 max-w-md mx-8" data-testid="search-form">
            <div className="relative w-full">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-white/40" />
              <input
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Search movies, channels, genres..."
                data-testid="search-input"
                className="w-full bg-white/5 border border-white/10 rounded-full pl-10 pr-4 py-2 text-sm placeholder-white/30 focus:outline-none focus:ring-2 focus:ring-[#E65F2B]/50 focus:bg-white/10 transition"
              />
            </div>
          </form>
        ) : <div className="flex-1" />}

        <nav className="flex items-center gap-3">
          <Link to="/browse" className="hidden sm:inline text-sm text-white/70 hover:text-white transition" data-testid="nav-browse">Browse</Link>
          {!authed && (
            <>
              <Link to="/login" className="text-sm text-white/70 hover:text-white transition" data-testid="nav-login">Sign in</Link>
              <Link to="/register" className="ember-btn !py-2 !px-4 text-sm" data-testid="nav-register">Get Started</Link>
            </>
          )}
          {authed && (
            <>
              {user.role === "creator" && (
                <Link to="/creator" className="hidden sm:inline-flex items-center gap-1.5 text-sm text-white/70 hover:text-white transition" data-testid="nav-creator">
                  <Upload className="h-4 w-4" /> Creator
                </Link>
              )}
              {user.role === "admin" && (
                <Link to="/admin" className="hidden sm:inline-flex items-center gap-1.5 text-sm text-white/70 hover:text-white transition" data-testid="nav-admin">
                  <Shield className="h-4 w-4" /> Admin
                </Link>
              )}
              <Link to="/profile" className="inline-flex items-center gap-1.5 text-sm text-white/70 hover:text-white transition" data-testid="nav-profile">
                <User className="h-4 w-4" /> {user.name?.split(" ")[0]}
              </Link>
              <button
                onClick={() => { logout(); nav("/"); }}
                className="inline-flex items-center gap-1.5 text-sm text-white/50 hover:text-white transition"
                data-testid="nav-logout"
                title="Logout"
              >
                <LogOut className="h-4 w-4" />
              </button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
